import { Ban, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function UnauthorizedView() {
  const { user, logout } = useAuth();
  return <main className="center-screen unauthorized" data-testid="unauthorized-view"><Ban size={34} /><span className="overline">Access denied</span><h1>Not authorized</h1><p>The account <strong>{user?.email || "you used"}</strong> does not have an AuraLive moderator role.</p><button className="button danger" onClick={logout} data-testid="unauthorized-logout-button"><LogOut size={16} />Sign out</button></main>;
}